module.exports = __webpack_public_path__ + "img/tv-w.svg";